import React from 'react';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { SimilarListingsCTA } from './similar_listings_cta';
import { getSimilarListingPageRoute } from './shared/url_helpers';

interface IProps {
  make: string;
  model: string;
  listingId: string;
}

export function Item2EndedListingSearchButton(props: IProps) {
  trackEvent(
    {
      eventName: MParticleEventName.ViewedEndedListing,
      listingId: props.listingId,
    },
  );

  const clickEvent = {
    componentName: 'EndedListingSearchButton',
    eventName: MParticleEventName.ClickedComponent,
    position: 0,
  };

  return (
    <div className="item2__ended-search-button">
      <SimilarListingsCTA
        similarListingsLink={getSimilarListingPageRoute(props.listingId, props.make, props.model)}
        clickEvent={clickEvent}
        hideArrowIcon={false}
      />
    </div>
  );
}
